import type {
  FindUserReservationFlightReservation,
  FindUserReservationHotelReservation,
} from "@/app/lib/types/codegen";
import { useTranslations } from "use-intl";
import { OrderStatusSection } from "../OrderStatusSection";
import { formatCurrency } from "@/app/lib/utils/currency";
import { Link } from "@mui/material";
import { WHATSAPP_URL } from "@/app/lib/routes";
import dayjs from "dayjs";

type Props = {
  reservation:
    | FindUserReservationFlightReservation
    | FindUserReservationHotelReservation;
};

export const OrderDetailsWithoutReservation = ({ reservation }: Props) => {
  const t = useTranslations();

  return (
    <>
      <OrderStatusSection status={reservation.status} />
      <section>
        <ul className="section-card w-full items-center justify-between gap-4 space-y-2 text-sm">
          <li className="flex w-full items-center justify-between">
            <span className="text-text-title">
              {t("reservations.orderId")}:
            </span>
            <span className="font-semibold text-text-title">
              {reservation.id}
            </span>
          </li>
          <li className="flex w-full items-center justify-between">
            <span className="text-text-title">
              {t("reservations.bookingTime")}:
            </span>
            <span className="font-semibold text-text-title">
              {dayjs(reservation.createdAt).format("HH:mm, DD MMM YYYY")}
            </span>
          </li>
          <li className="flex w-full items-center justify-between">
            <span className="text-text-title">{t("flights.totalPrice")}:</span>
            <span className="font-semibold text-text-title" dir="ltr">
              {formatCurrency(reservation.price, reservation.currency)}
            </span>
          </li>
        </ul>
      </section>
      <section className="section-card mt-4 flex w-full flex-col items-start gap-1 space-y-2">
        <h3 className="mb-2 text-sm font-semibold">
          {t("reservations.doYouNeedMoreInformation")}
        </h3>
        <p className="text-sm text-text-primary">
          {t("reservations.reachSupportTeam")}
        </p>
        <Link
          underline="hover"
          href={WHATSAPP_URL}
          target="_blank"
          sx={{ paddingBlock: "calc(var(--spacing) * 2)" }}
        >
          <span className="text-sm">{t("contactWhatsAppSupport")}</span>
        </Link>
      </section>
    </>
  );
};
